import { render } from "./AddGuestToManifestoForm.vue?vue&type=template&id=3732e5f4"
import script from "./AddGuestToManifestoForm.vue?vue&type=script&lang=js"
export * from "./AddGuestToManifestoForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__